import React from 'react'
import cx from 'classnames'
import { ItemMenu } from './ItemMenu'
import { NAV_MENU } from '../constant'
import '../index.scss'

export const NavMenu = (
  key,
  item,
  dragStartMenu,
  dragEnterMenu,
  dropMenu,
  navMenuIndex,
  type,
  pathname,
  sidebarSectionExpanded,
  setSidebarSectionExpanded,
  isSideNavExpanded,
  Components,
  onClickItem,
  dragStartItem,
  dragEnterItem,
  enableDragAndDrop
) => {
  const uniqueClassname = 'class-per-BDD-masterdata'
  const menuProps = {
    key: item.id || item.title,
    renderIcon: item.icon,
    title: item.title,
    'aria-label': item.title,
    menuLinkName: item.title,
    className: cx(
      `ublique-${type}-navigation-items-item`,
      `ublique-${type}-navigation-items-item-menu`,
      uniqueClassname
    ),
    actions: item.actions
  }
  const { Menu } = Components
  const toggleExpanded = (id) => {
    setSidebarSectionExpanded((prevState) => {
      if (!prevState) {
        return {
          [id]: true
        }
      }

      return {
        ...prevState,
        [id]: prevState[id] ? !prevState[id] : true
      }
    })
  }

  if (type === 'sidebar') {
    menuProps.isExpanded = sidebarSectionExpanded
      ? sidebarSectionExpanded[item.name]
      : false
    menuProps.toggleExpanded = () => toggleExpanded(item.name)
    menuProps.isActive = item.items.some(
      (menuItem) => menuItem.href === pathname
    )
  }

  const element = document.getElementsByClassName(uniqueClassname)[0]
  if (element) {
    element.id = 'BDD_' + item.id
  }

  return (
    <Menu
      key={`${navMenuIndex}-${key}`}
      {...menuProps}
      onDragStart={(e) => dragStartMenu(e, navMenuIndex)}
      onDragEnter={(e) => dragEnterMenu(e, navMenuIndex, item.name)}
      onDragEnd={(e) => dropMenu(e, navMenuIndex, NAV_MENU)}
      draggable={enableDragAndDrop}
    >
      {item.items.map((el, idx) =>
        ItemMenu(
          el,
          null,
          null,
          Components,
          onClickItem,
          type,
          pathname,
          isSideNavExpanded,
          idx,
          dragStartItem,
          dragEnterItem,
          dropMenu,
          navMenuIndex,
          enableDragAndDrop
        )
      )}
    </Menu>
  )
}
